import * as React from "react";
import {connect} from "react-redux";
import SelectDictionaryItem from "../../../common/select/SelectDictionaryItem";
import {RootState} from "../../../../../store/reducer/root/RootState";

class SelectActivityTemplate extends SelectDictionaryItem {
	onInputChange(value: string) {
		this.props.onInputChange(value);
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.survey.activityTemplates,
	}
}

export default connect(mapStateToProps)(SelectActivityTemplate)